import { render } from "./VerifyProduct.vue?vue&type=template&id=45df6ad2&scoped=true"
import script from "./VerifyProduct.vue?vue&type=script&lang=js"
export * from "./VerifyProduct.vue?vue&type=script&lang=js"

import "./VerifyProduct.vue?vue&type=style&index=0&id=45df6ad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45df6ad2"]])

export default __exports__